import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '眠境 - 助眠 ASMR 内容精选平台',
  url: 'https://sleepono.github.io/',
  description: '探索最有效的助眠 ASMR 内容精选，涵盖雨声、耳语、敲击等多种触发音效，帮助您快速放松神经、缓解失眠焦虑。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://sleepono.github.io/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '什么是 ASMR 助眠？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ASMR（Autonomous Sensory Meridian Response，自发性知觉经络反应）是一种通过特定声音或视觉刺激引发的放松反应。ASMR 助眠利用雨声、耳语、敲击音等触发音效，帮助大脑放松、减缓思绪，从而促进自然入睡。',
      },
    },
    {
      '@type': 'Question',
      name: '听 ASMR 助眠安全吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ASMR 助眠是安全的非药物助眠方式。只要控制好音量（建议不超过60分贝），不会对听力造成伤害。建议使用外放或骨传导耳机。',
      },
    },
    {
      '@type': 'Question',
      name: '每天听多久 ASMR 比较合适？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '建议每天睡前收听20-40分钟。如果中途已经入睡，可以设置定时关闭。不建议整夜持续播放。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}